var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdvantagesCompany = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8066 19.4342C38.8066 30.1967 30.1052 38.8778 19.2728 38.8197C8.37864 38.7604 -0.228987 29.7567 0.00464557 18.9764C0.229976 8.57324 8.75814 -0.00829563 19.4329 6.01811e-06C30.1468 0.00830767 38.8054 8.69421 38.8054 19.4354L38.8066 19.4342ZM33.0239 20.0924C33.5208 12.7869 27.7096 6.26775 20.1883 5.81353C12.8295 5.3688 6.27358 10.9689 5.82292 18.6858C5.39953 25.9415 10.9498 32.8532 19.1945 33.0406C26.6873 33.2114 32.6859 27.2899 33.0239 20.0924Z",
    fill: "url(#paint0_linear_7042_13206)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14L17.4211 24L13 20.1111",
    stroke: "#B21941",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7042_13206",
    x1: -0.0719424,
    y1: 40.0346,
    x2: 124.275,
    y2: 43.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#208AC6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdvantagesCompany);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AdvantagesCompany.ec50d1015a3f9b8cf1c3ccf71880577f.svg";